import { Link } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import { IconChevronRight, IconOffersFlame, Pressable, Text, tokens } from '@fhs/ui';
import { useStoreContext } from '@fhs-legacy/frontend/src/state/store';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

import { useMenuClickEvents } from '../analytics';
import { getOffersAndRewardsHref } from '../utils';

const OFFERS_TILE_HEIGHT = 56;

export function MenuOffersAndRewards() {
  const enableRewardsTiers = useFlag('enable-rewards-tiers');
  const { noStoreSelected } = useStoreContext();
  const href = getOffersAndRewardsHref(enableRewardsTiers, noStoreSelected);
  const { logMenuClickEvent } = useMenuClickEvents();

  return (
    <Link href={href} asChild>
      <Pressable
        accessibilityRole="link"
        accessibilityLabel="Offers & Rewards"
        borderRadius={8}
        style={styles.offersTile}
        onPress={() => logMenuClickEvent({ text: 'Offers & Rewards' })}
      >
        <View style={styles.offersLeft}>
          <IconOffersFlame size={30} />
          <Text.Heading type="two" numberOfLines={1} style={styles.offersLabel}>
            Offers & Rewards
          </Text.Heading>
        </View>
        <IconChevronRight size={28} color={tokens.colors.$black} />
      </Pressable>
    </Link>
  );
}

const styles = StyleSheet.create({
  offersTile: {
    height: OFFERS_TILE_HEIGHT,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 16,
    paddingRight: 24,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    borderRadius: 8,
  },
  offersLeft: {
    flex: 1,
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  offersLabel: {
    lineHeight: 25,
  },
});
